import { createStore } from 'vuex'
import Notify from 'quasar/src/plugins/Notify.js';
import $router from '@/router';

export default createStore({
  state: {
    loader : false,
    user : null,
  },
  mutations: {
    showLoader(state, payload){
      state.loader = payload
    },
    setUser(state,payload){
      state.user = payload      
    },
    async logOut() {
      localStorage.clear()
      await $router.push('/')
      location.reload()
    }
  },
  actions: {
    loadUser({commit}){
      if(localStorage.getItem('sicope-user')) {
        commit('setUser', JSON.parse(localStorage.getItem('sicope-user')))
      } else {
        commit('setUser', { IdUsuario: 0, Nombre: "usuario-nombre", Usuario: "sicope-usuario", TipoUsuario: 99, Token: "sin-token", IsLogged: false })
      }
    },
    logOut({commit}){
      commit('logOut')
    },
    alert(a,obj){
      Notify.create({
        color: obj.color,
        textColor :'white',
        position: 'top',
        message: obj.message,
        multiLine : true,
        html: true
      })
    },
  },
  modules: {
  }
})
